import { Component, Input, OnChanges, OnInit, SimpleChanges } from '@angular/core';
import { ActivatedRoute, ParamMap } from '@angular/router';
import { PetService } from '../../../services/pet.service';
import { MONITOR_ANES, MONITOR_BREATH, MONITOR_FLUIDS, HYDRATION, LUNG_SOUNDS, HEARTH_SOUNDS, PULSE_QUALITY, MM_COLOR, CRT } from '../../../../environments/environment';
import Swal from 'sweetalert2';

declare var $: any;

@Component({
  selector: 'ngx-work-profile-vital',
  templateUrl: './profile-vital.component.html',
  styleUrls: ['./profile-vital.component.scss']
})
export class ProfileVitalComponent implements OnInit {

  private _pet_no: number;
  MONITOR_ANES = MONITOR_ANES;
  MONITOR_FLUIDS = MONITOR_FLUIDS;
  MONITOR_BREATH = MONITOR_BREATH;
  HYDRATION = HYDRATION;
  LUNG_SOUNDS = LUNG_SOUNDS;
  HEARTH_SOUNDS = HEARTH_SOUNDS;
  PULSE_QUALITY = PULSE_QUALITY;
  MM_COLOR = MM_COLOR;
  CRT = CRT

  @Input() set pet_no(value: number) {
    this._pet_no = value;
    this.petService.getVitalsByPetId(this.petService.current_pet_no).then(() => { });
  }

  get pet_no(): number {
    return this._pet_no;
  }

  constructor(
    public petService: PetService,
    private route: ActivatedRoute
  ) {
  }

  ngOnInit() {
    this.petService.changePet
      .subscribe(message => {
        if (message !== this.pet_no) {
          this.pet_no = message;
        }
      });
  }

  // Fields touched since the last successful save, keyed by the DB row they belong to
  // (tag26/tag26bis share one row, so they're tracked under the same 'tag26' key).
  touchedVitalFields = new Set<string>();

  save() {
    if (this.touchedVitalFields.size === 0) return;

    Swal.fire({
      title: 'Loading...',
      timerProgressBar: true,
      didOpen: () => {
        Swal.showLoading()
      },
    })

    const touched = Array.from(this.touchedVitalFields);
    this.petService.setupPetVitals(touched)
        .then(() => {
            this.touchedVitalFields.clear();
            Swal.close();

            Swal.fire({
              title: 'Information stored correctly',
              didOpen: () => {
              },
            })
        });
  }

  // Marks a field dirty as the user edits it; no API call here - the Save button
  // is the only thing that persists, and it only sends fields marked here.
  markVitalTouched(fieldKey: string) {
    this.touchedVitalFields.add(fieldKey);
  }

}
